// extracted by mini-css-extract-plugin
export default {"goTop":"GoTopStyle_goTop__jlZzX","goTopHidden":"GoTopStyle_goTopHidden__z2e5V"};